import styled from 'styled-components'

export const ContentBlur = styled.div`
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(4px);
  --webkit-backdrop-filter: blur(4px);
  padding: 6px;
  border-radius: 8px;
`

export const CloseButton = styled(ContentBlur)`
  position: absolute;
  right: 16px;
  top: 42px;
  z-index: 3;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`
